
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import NotSupportedBrowser from './NotSupportedBrowser.vue'

export default {
  name: 'VideoPlayer',
  components: {
    NotSupportedBrowser
  },
  props: {
    video: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      player: null,
      path: '',
      token: '',
      forward: 0,
      forwardTimeout: null,
      lastTap: 0,
      tapThreshold: 500, // 500ms içinde ikinci dokunma çift dokunma sayılır
      showBrowserWarning: false,
    }
  },
  methods: {
    isSafariBrowser() {
      return Boolean(videojs.browser && videojs.browser.IS_ANY_SAFARI)
    },
    canUseVhsOnSafari() {
      if (typeof window === 'undefined') return false
      const MediaSource = window.MediaSource || window.WebKitMediaSource
      return Boolean(
        MediaSource &&
          typeof MediaSource.isTypeSupported === 'function' &&
          MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"')
      )
    },
    getHtml5Options() {
      const forceVhs = this.isSafariBrowser() && this.canUseVhsOnSafari()

      return {
        vhs: {
          // Safari native HLS, beforeRequest kancasını atlar; jwt_token eklenemez.
          overrideNative: forceVhs || !this.isSafariBrowser(),
          enableLowInitialPlaylist: true,
          smoothQualityChange: true,
          handlePartialData: true,
        },
        nativeAudioTracks: !forceVhs,
        nativeVideoTracks: !forceVhs,
      }
    },
    detectDoubleClick(event) {
      const isLeftSide = window.innerWidth / 2 > event.clientX
      if (isLeftSide) {
        this.handleDoubleClick(-10)
      } else {
        this.handleDoubleClick(10)
      }
    },
    handleClick() {
      if (this.player.paused()) {
        this.player.play()
      } else {
        this.player.pause()
      }
    },
    handleDoubleClick(value) {
      if (this.forwardTimeout) clearTimeout(this.forwardTimeout)
      this.forward += value
      this.forwardTimeout = setTimeout(() => {
        this.player.currentTime(this.player.currentTime() + this.forward)
        this.forward = 0
      }, 400)
    },
    isMp4Url(url) {
      return /\.mp4(\?|$|#)/i.test(url)
    },
    hasJwtTokenInUrl(url) {
      return /[?&]jwt_token=/i.test(url)
    },
    appendJwtToken(url, token) {
      if (!token || this.isMp4Url(url) || this.hasJwtTokenInUrl(url)) return url
      const separator = url.includes('?') ? '&' : '?'
      return `${url}${separator}jwt_token=${encodeURIComponent(token)}`
    },
    getVideoSource() {
      const src = this.appendJwtToken(this.path, this.token)
      return {
        src,
        type: this.isMp4Url(this.path) ? 'video/mp4' : 'application/x-mpegURL',
      }
    },
    async setVideos() {
      if (this.video.videoPath !== '') {
        const videoSlashLength = this.video.videoPath.split('/')
        if (videoSlashLength.length > 1) {
          const url = await this.$api.get(
            `Videos/GetCDNStream/${this.video.id}`
          )
          if (url.message === 'OK') {
            this.path = url.data.link
            this.token = url.data.token
          }
        } else {
          this.path = this.$api.path(
            `Videos/GetStream/${this.video.id}/720/part.m3u8`
          )
          this.token = ''
        }
      }
      this.startVideo()
    },
    startVideo() {
      const vm = this
      const videoSource = this.getVideoSource()

      videojs.Vhs.xhr.beforeRequest = (option) => {
        option.uri = vm.appendJwtToken(option.uri, vm.token)
        return option
      }

      this.player = videojs(
        this.$refs.videoPlayer,
        {
          live: true,
          autoplay: false,
          controls: true,
          doubleClick: false,
          playbackRates: [0.5, 1, 1.5, 2],
          html5: this.getHtml5Options(),
          sources: [videoSource],
        },
        () => {
          setTimeout(() => {
            this.$emit('video:init', vm.player)
          }, 150)
          this.player.on('play', function () {
            vm.$emit('video:play', vm.player)
          })
          this.player.on('playing', function () {
            vm.$emit('video:playing', vm.player)
          })

          this.player.on('pause', function () {
            vm.$emit('video:pause', vm.player)
          })

          this.player.on('seeking', function () {
            vm.$emit('video:seeking', vm.player)
          })

          this.player.on('seeked', function () {
            vm.$emit('video:seeked', vm.player)
          })

          this.player.on('ended', function () {
            vm.$emit('video:ended', vm.player)
          })
          this.player.on('error', function () {
            if (vm.isSafariBrowser() && !vm.showBrowserWarning) {
              vm.showBrowserWarning = true
              vm.player.dispose()
              vm.player = null
            }
            vm.$emit('video:error', vm.player)
          })

          this.player.el().addEventListener('dblclick', function (e) {
            handleSeek(e.clientX)
            e.preventDefault()
            e.stopPropagation()

          }, true)

          this.player.el().addEventListener('touchstart', function (e) {
           // if(!vm.player.paused()) e.stopPropagation()
            e.preventDefault()
            const currentTime = new Date().getTime()
            const tapLength = currentTime - vm.lastTap

            if (tapLength < vm.tapThreshold && tapLength > 0) {
              // Çift dokunma algılandı
              const touch = e.touches[0]
              handleSeek(touch.clientX)
              e.preventDefault()
            }

            vm.lastTap = currentTime
          }, true)

          const handleSeek = (clientX) => {
            const bounds = this.player.el().getBoundingClientRect()
            const x = clientX - bounds.left
            const width = bounds.width
            const currentTime = this.player.currentTime()
            const seekAmount = 10

            if (x < width / 2) {
              this.player.currentTime(Math.max(0, currentTime - seekAmount))
            } else {
              this.player.currentTime(
                Math.min(this.player.duration(), currentTime + seekAmount)
              )
            }
          }
        }
      )
    },
  },
  mounted() {
    this.setVideos()
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  },
}
